import { Component, Input } from '@angular/core';
import { EIconPath } from '../../../../../../../shared/enums/icons.enum';
import { TActivityChange } from '../../activity-change.model';

@Component({
    selector: 'pp-dashlet-activity-title',
    templateUrl: './dashlet-activity-title.component.html',
    styleUrls: ['../../dashlet-activity.component.scss'],
    standalone: false
})
export class DashletActivityTitleComponent {
  @Input() ppChange: TActivityChange<string>;

  EIconPath = EIconPath;
}
